module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5Go81"))).then(() => parcelRequire('5erN3'));